/**
 * IconButton component overrides.
 * Rounded icon buttons with smooth hover transitions.
 */

import type { Theme } from '@mui/material/styles';

const iconButton: Theme['components'] = {
  MuiIconButton: {
    styleOverrides: {
      root: {
        borderRadius: 'var(--mui-shape-customBorderRadius-sm)',
        transition: 'all 150ms ease',
        '&:hover': {
          backgroundColor: 'var(--mui-palette-action-hover)',
        },
      },
      sizeSmall: {
        width: 32,
        height: 32,
      },
      sizeMedium: {
        width: 40,
        height: 40,
      },
      sizeLarge: {
        width: 48,
        height: 48,
      },
    },
  },
};

export default iconButton;
